<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">Enterprise management consulting</div>
      <div class="contentTitle">企业管理咨询</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="yjh_item">
        <div class="yjh_item_text text_left">
          <div class="text_box">
            <div class="text_line"></div>
            <div class="text_title">企业管理咨询简介！</div>
          </div>
          <div class="text_content">
            信息瞬息万变的今天，企业经营者、决策者需要时刻关注商业环境的变化，保持清晰、准确的视角，来做出决策和改变。云久鸿深耕人力资源行业多年，积累了丰富的行业经验，可帮助企业聚焦经营管理中的关键问题，以科学的分析方法，寻找成因，提供针对性的解决方案，帮助企业改善的经营管理状况。
          </div>
        </div>
        <div class="yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentTitle noStitle">企业管理咨询</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">企业管理咨询简介！</div>
        </div>
        <div class="mobile_yjh_item_content">
          信息瞬息万变的今天，企业经营者、决策者需要时刻关注商业环境的变化，保持清晰、准确的视角，来做出决策和改变。云久鸿深耕人力资源行业多年，积累了丰富的行业经验，可帮助企业聚焦经营管理中的关键问题，以科学的分析方法，寻找成因，提供针对性的解决方案，帮助企业改善的经营管理状况。
        </div>
        <div class="mobile_yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
}
</script>

<style lang="less" scoped></style>
